/* eslint-disable no-param-reassign */
const { has } = require('ramda')

function mergeWith (fn, obj1, obj2) {
  Object.keys(obj2).forEach((key) => {
    if (has(key, obj1)) {
      obj1[key] = fn(obj1[key], obj2[key])
      return
    }

    obj1[key] = obj2[key]
  })

  return obj1
}

function pushAll (array1, array2) {
  array1.push(...array2)
  return array1
}

function mergeConcat (obj1, obj2) {
  return mergeWith(pushAll, obj1, obj2)
}

module.exports = {
  pushAll,
  mergeConcat,
  mergeWith,
}
